import { useParams } from 'react-router-dom';

import type { SpecificationDetailPathParams } from '@/shared/lib/react-router';

export const useSpecificationIdFromPathParams = () => {
  const routerParams = useParams<SpecificationDetailPathParams>();
  return Number(routerParams.specificationId);
};
